/* -------------------------------------------------------------------------- */
/*                           Match fact item styles                           */
/* -------------------------------------------------------------------------- */

@import './pk-match-fact-event.variables';

:host {
  @apply flex w-full;
}

.pk-match-fact-event {
  @apply text-[color:--pk-match-fact-event--text-color];

  font-family: var(--pk-match-fact-event--font-family);
}

.pk-match-fact-event.team-away {
  @apply flex-row-reverse;
}

.pk-match-fact-event__end-phase {
  @apply bg-[--pk-match-fact-event--endPhase-background-color] sm:rounded-l;

  &,
  ::slotted(*) {
    @apply font-regular text-xs2 leading-m text-text-02;
  }
}
